export const skipEmpty = (arg: unknown) =>
  Object.fromEntries(Object.entries(arg ?? {}).filter(([_, value]) => Boolean(value)));
